// extracted by mini-css-extract-plugin
export default {"news":"DailyNews_news__phXbw","first-ann":"DailyNews_first-ann__TVhfP","ann":"DailyNews_ann__0sCAh"};